const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "#9FBEED",
    style: {
      fill: "#9FBEED",
      fill: "color(display-p3 0.6235 0.7431 0.9294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 19C26.38 19 24.25 21.13 24.25 23.75C24.25 26.32 26.26 28.4 28.88 28.49C28.96 28.48 29.04 28.48 29.1 28.49C29.12 28.49 29.13 28.49 29.15 28.49C29.16 28.49 29.16 28.49 29.17 28.49C31.73 28.4 33.74 26.32 33.75 23.75C33.75 21.13 31.62 19 29 19Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08 31.1499C31.29 29.2899 26.74 29.2899 23.93 31.1499C22.66 31.9999 21.96 33.1499 21.96 34.3799C21.96 35.6099 22.66 36.7499 23.92 37.5899C25.32 38.5299 27.16 38.9999 29 38.9999C30.84 38.9999 32.68 38.5299 34.08 37.5899C35.34 36.7399 36.04 35.5999 36.04 34.3599C36.03 33.1299 35.34 31.9899 34.08 31.1499ZM31 35.1299H29.75V36.3799C29.75 36.7899 29.41 37.1299 29 37.1299C28.59 37.1299 28.25 36.7899 28.25 36.3799V35.1299H27C26.59 35.1299 26.25 34.7899 26.25 34.3799C26.25 33.9699 26.59 33.6299 27 33.6299H28.25V32.3799C28.25 31.9699 28.59 31.6299 29 31.6299C29.41 31.6299 29.75 31.9699 29.75 32.3799V33.6299H31C31.41 33.6299 31.75 33.9699 31.75 34.3799C31.75 34.7899 31.41 35.1299 31 35.1299Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoLink);
export default __webpack_public_path__ + "static/media/auto-link.b9ff2eb8916ac25c4bdc6d1db237e4ab.svg";
export { ForwardRef as ReactComponent };